// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ccaee50a","239":"9dbe72b7","455":"4194fde2"}[chunkId] + ".chunk.js";
};